import { BackButton } from "components/BackButton";
import { useParams } from "react-router-dom";
import LoadingAnimation from "components/LoadingAnimation";
import { MarketPositionSymbol } from "components/MarketPositionSymbol";
import { useGetMembers } from "hooks/partnerApi/useGetMembers";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { ACCOUNT_PROVIDERS } from "@letsbit/malcolmlb";

export const MemberLocalMarketPositionsSymbolPage: React.FC = () => {
  const { uid, symbol } = useParams<{ uid: string; symbol: string }>();
  const { data: members } = useGetMembers();

  const { positions, position, name } = useMemo(() => {
    const member = members?.flat().find((member) => member.uid === uid);
    const memberPositions = member?.local_market_positions || [];
    const memberName =
      member?.natural_person_data?.first_name +
        " " +
        member?.natural_person_data?.last_name || "";
    const position = memberPositions.find(
      (position) => position.symbol.toLowerCase() === symbol?.toLowerCase(),
    );
    return {
      positions: memberPositions,
      position,
      name: memberName,
    };
  }, [members, uid]);

  return !(positions && symbol && uid) ? (
    <LoadingAnimation />
  ) : (
    <div className="flex h-full w-full flex-col p-4">
      <div className="mb-6 flex items-center justify-between border-b border-[--milkylb-color-neutral-200] pb-8">
        <div className="flex flex-col items-start">
          <BackButton className="mb-4" />
          <h1 className="font-['Tomato_Grotesk'] text-4xl">
            <FormattedMessage
              {...messages.title}
              values={{ name, symbol: position?.asset.friendly_name }}
            />
          </h1>
        </div>
      </div>
      <MarketPositionSymbol
        positions={positions}
        symbol={symbol}
        memberUid={uid}
        provider={ACCOUNT_PROVIDERS.ESCO}
      />
    </div>
  );
};
